import React from "react";
import useTranslation from '../../../../Hooks/useTranslation';

interface Props{
	onChange?: (value: any) => void;
	placeholder?: string;
}

const TextInput: React.FC<Props> = ({placeholder, onChange}) => {
	const {t} = useTranslation();

	return (
		<input
			className='form-control'
			placeholder={t(placeholder)}
			onChange={onChange}
		/>
	)
}

export default TextInput;